import { IContractForm } from '@bp-core/src/lib/models/portal/goal/contract.form';
import { ICustomPortfolioResult } from '@bp-core/src/lib/models/portal/goal/custom-portfolio-result.model';
import { IInvestmentUserflowType } from '@bp-core/src/lib/models/portal/goal/goal.model';
import { MeFinancialEntityModel } from '@bp-core/src/lib/proto/portal-user.pb';
import {
  FundingModel,
  GoalCategoryModel,
  GoalModel,
  InvestmentStrategyModel,
  InvestmentStrategyTypeModel,
  InvestmentTypeModel,
  PortfolioModel,
  RiskLevelModel,
  UserModel,
} from 'projects/bp-core/src/lib/proto/common-message.pb';
import { ISubcategoryWithFundsResult } from '../../models/subcategory-with-funds';

export interface GoalNewContext {
  error: string | null;
  goal: GoalModel;
  goalTitle: string | undefined;
  entityContractForm: IContractForm | undefined;
  user: UserModel | undefined;
  defaultGoalCategory: GoalCategoryModel | undefined;
  defaultPortfolio: PortfolioModel | undefined;
  goalCategorySelected: GoalCategoryModel | undefined;
  hasOneFinancialEntity: boolean;
  saveState: Record<string, any> | undefined;
  goalImage: string | undefined;
  userFlowTypeSelected: string | undefined;
  investmentStrategySelected: InvestmentStrategyModel | undefined;
  investmentStrategyTypeSelected: InvestmentStrategyTypeModel | undefined;
  goalPortfolioSelected: PortfolioModel | undefined;
  goalRiskLevelSelected: RiskLevelModel | undefined;
  portfoliosFilteredForFinancialEntity: PortfolioModel[] | undefined;
  subCategoryWithCustomFundsResult: ISubcategoryWithFundsResult | undefined;
  meFinancialEntities: MeFinancialEntityModel[] | undefined;
  customPorfolioResult: ICustomPortfolioResult | undefined;
  customInvestmentStrategy: InvestmentStrategyModel | undefined;
  investmentStrategyTypes: InvestmentStrategyTypeModel[] | undefined;
  investmentStrategies: InvestmentStrategyModel[] | undefined;
  investmentTypes: InvestmentTypeModel[] | undefined;
  userflowTypes: IInvestmentUserflowType[] | undefined;
  canChangeRiskLevel: boolean;
  vectorBoxFunding: FundingModel | undefined;
  comesFrom: string | undefined;
  showSemiLiquidFlow: boolean;
}

export enum GoalStateEnum {
  loading = 'loading',
  start = 'start',
  goalCategorySelection = 'goalCategorySelection',
  financialEntitySelection = 'financialEntitySelection',
  goalNameEntry = 'goalNameEntry',
  goalImageSelection = 'goalImageSelection',
  goalCustomization = 'goalCustomization',
  userflowTypeSelection = 'userflowTypeSelection',
  investmentStrategyTypeSelection = 'investmentStrategyTypeSelection',
  investmentStrategySelection = 'investmentStrategySelection',
  goalResume = 'goalResume',
  goalCustomPortfolio = 'goalCustomPortfolio',
  riskLevelSelection = 'riskLevelSelection',
  goalSimulator = 'goalSimulator',
  success = 'success',
}

// Asegúrate de importar 'keyof typeof'
export type GoalStateKey = keyof typeof GoalStateEnum;

export interface GoalNewSchema {
  states: Record<GoalStateKey, any>;
}

// // Esquema de estado para XState
// export interface GoalNewSchema {
//   states: Record<GoalStateEnum, any>;
// }

// export const goalNewSchema: GoalNewSchema = {
//   states: Object.assign({}, ...Object.values(GoalStateEnum).map(state => ({ [state]: {} }))),
// };
